/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from "react";
import { connect } from "react-redux";
import Icon from "@gerenciatd/next.components.icon-n";
import CustomLink from "@gerenciatd/next.components.custom-link";
import TextInfo from "@gerenciatd/next.components.text-info-n";
import {clickCookies} from '@/components/one-trust'
// genero version

const COMPONENT_NAME = "Footer";

const TAGGING_INFO = {
  componentVariation: "all",
  componentProduct: "",
  componentName: COMPONENT_NAME,
  componentContent: ``,
};

class Footer extends Component {
  constructor(props) {
    super(props);
    const state = {
      0: {
        1: false,
        2: false,
        3: false,
        4: false,
      },
      1: {
        1: false,
        2: false,
        3: false,
        4: false,
      },
    };
    this.state = state;
  }

  createSpecificClassName = (id) => {
    switch (id) {
      case "cookies":
        return "optanon-toggle-display";
      default:
        return "";
    }
  };

  createSpecificOnClick = (id) => {
    switch(id){
      case 'cookies':
        return () => {
          clickCookies({
            type: 'settings',
            handlerStyles: false,
            callback: () => {}
          })
        }
    }

    return null;
  }

  handleTogle = (row, column) => {
    const allInfo = { ...this.state };

    allInfo[row][column] = !allInfo[row][column];

    this.setState({
      ...allInfo,
    });
  };

  render() {
    const { footerInfo } = this.props;
    if (!footerInfo || !footerInfo.about || !footerInfo.links) {
      return null;
    }
    if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
      return null;
    }
    const status = this.state;
    const { links, about } = footerInfo;
    const linksKeys = Object.keys(links);
    const aboutKeys = Object.keys(about);
    return (
      <footer id="footerRoot">
        <div className="footer xux">
          <div className="section particulares">
            <div className="container footer_container">
              {linksKeys.map((key, index) => {
                const rowIndex = index;
                const currentRow = links[key];
                const keytop = `rowIndex-${rowIndex}-${index.toString()}`;
                return (
                  <div key={keytop} className="footer_row collapsable_menu_row">
                    {currentRow.map((currentList, indexito) => {
                      const currentClassName = `collapsableMenu collapsableMenu_0_1 collapsableMenu${
                        status[rowIndex][indexito] ? "--show" : "--hidden"
                      }`;
                      const { title, items } = currentList;
                      const cheuronStatus = status[rowIndex][indexito] ? 'cheuronup' : 'cheurondown'
                      const cheuronCss = `SvgIconLoader ${
                        status[rowIndex][indexito]
                          ? "icon0-cheuronup-m"
                          : "icon0-cheurondown-m"
                      } SvgIconLoader-color-gp--black SvgIconLoader-bgColor-gp--transparent cheuronTogle`;
                      return (
                        <div
                          key={`${keytop}-${indexito}`}
                          className={currentClassName}
                        >
                          <div className="collapsableMenu_head particulares">
                            <div className="collapsableMenu_head_container particulares">
                              <TextInfo
                                kind="span"
                                size="title05"
                                color="grey5"
                                text={title}
                                fontType="font-light"
                                className="collapsableMenu_title"
                              />
                              <Icon className={cheuronCss} id={cheuronStatus} />
                              <CustomLink
                                aria-label={title}
                                title={title}
                                onClick={() =>
                                  this.handleTogle(rowIndex, indexito)
                                }
                                taggingInfo={{
                                  ...TAGGING_INFO,
                                  componentContent: `Footer-Collapsable-${rowIndex}`,
                                }}
                                className="CustomLink linkoverbox titleLink"
                              />
                            </div>
                            <div className="collapsableMenu_items particulares">
                              {items.map((item) => {
                                const {
                                  id,
                                  target,
                                  label,
                                  link,
                                  title: itemTitle,
                                } = item;
                                return (
                                  <div key={`${id}-${label}`} className="item">
                                    <CustomLink
                                      id={id}
                                      aria-label={itemTitle}
                                      title={itemTitle}
                                      href={link}
                                      target={target}
                                      taggingInfo={{
                                        ...TAGGING_INFO,
                                        componentContent: `Footer-link-${link}`,
                                      }}
                                    >
                                      <TextInfo
                                        kind="span"
                                        size="caption01"
                                        color="blue"
                                        text={label}
                                        fontType="font-light"
                                        className="regularLabel"
                                      />
                                    </CustomLink>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="section sectionrss particulares">
            <div className="container footer_container">
              {aboutKeys.map((aboutItemKey) => {
                const currentAboutRow = about[aboutItemKey];
                const { items, balloonItems, name, title } = currentAboutRow;
                return (
                  <div
                    id={`row ${name}`}
                    key={`about-${name}`}
                    className={`footer_row_link ${name} particulares`}
                  >
                    {items && (
                      <div className="items_container particulares">
                        {items.map((itemLink, indexito) => {
                          const {
                            id,
                            // title,
                            svgId,
                            label,
                            iconColor,
                            iconSize,
                            link,
                          } = itemLink;
                          const onClick = this.createSpecificOnClick(id);
                          // const customLinkClassName = this.createSpecificClassName(id);
                          const specialId = `itemLink-${id}-${label || ""}${
                            svgId || ""
                          }-${indexito}`;
                          const lessSpecialId = `itemLink-${id}`;

                         return (
                            <div
                              id={lessSpecialId}
                              key={specialId}
                              className="itemLink"
                            >
                              <div className="svgAndLabel">
                                {svgId && (
                                  <Icon
                                    {...itemLink}
                                    id={svgId}
                                    color={iconColor}
                                    size={iconSize}
                                    style={{
                                      paddingRight: "0.5rem",
                                    }}
                                  />
                                )}
                                {label && (
                                  <TextInfo
                                    kind="span"
                                    size="caption01"
                                    color="white"
                                    text={label}
                                    fontType="font-light"
                                    className="regularLabel"
                                    style={{
                                      paddingLeft: svgId ? "0.5rem" : "0rem",
                                    }}
                                  />
                                )}
                              </div>
                              <CustomLink
                                id={id}
                                aria-label={label}
                                className={this.createSpecificClassName(id)}
                                title={label}
                                taggingInfo={{
                                  ...TAGGING_INFO,
                                  componentContent: `Footer-link-${link}`,
                                }}
                                onClick={onClick}
                                href={id !== "cookies" ? link : null}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                    {balloonItems && (
                      <div className="balloon_container particulares">
                        {balloonItems.map((ballonItem, bindex) => {
                          const {
                            title: ballonTitle,
                            svgId,
                            label,
                            link,
                            iconSize,
                            iconColor,
                          } = ballonItem;
                          let svgIcon = null;
                          if (svgId) {
                            svgIcon = (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                }}
                              >
                                <Icon
                                  color={iconColor}
                                  id={svgId}
                                  size={iconSize}
                                  className="ballonIcon"
                                />
                              </div>
                            );
                          }
                          const specialId = `itemBalloon-${label || ""}${
                            svgId || ""
                          }-${bindex}`;
                          const lessSpecialId = `itemBalloon-${svgId || ""}`;
                          return (
                            <div
                              id={lessSpecialId}
                              key={specialId}
                              className="itemLink ballonItem"
                            >
                              {!label && svgIcon && (
                                <div className="balloon particulares">
                                  {svgIcon}
                                </div>
                              )}
                              <CustomLink
                                aria-label={ballonTitle}
                                title={ballonTitle}
                                href={link}
                                taggingInfo={{
                                  ...TAGGING_INFO,
                                  componentContent: `Footer-link-${link}`,
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state) => ({
  footerInfo: state.header.footerInfo,
});

export default connect(mapStateToProps, null)(Footer);
